import React from "react";
import PageSize from "./PageSize";
import Pagination from "./Pagination";

interface SearchPageFooterProps {
  totalRecords: number;
  pageSize: number;
  currentPage: number;
  gutterClassNames: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSearchParamsUpdated: (updates: Record<string, any>) => void;
}

export const SearchPageFooter: React.FC<SearchPageFooterProps> = ({
  totalRecords,
  pageSize,
  currentPage,
  gutterClassNames,
  onSearchParamsUpdated,
}) => {
  if (totalRecords === 0) {
    return null;
  }

  return (
    <div
      className={`search-page-footer ${gutterClassNames} h-[px] w-full flex my-4 gap-6 items-center justify-center sm:flex-col lg:flex-row`}
    >
      <div className="min-w-[93px]">
        <PageSize
          value={String(pageSize)}
          onChange={(value: string) => {
            onSearchParamsUpdated({ pageSize: Number(value), currentPage: 1 });
          }}
        />
      </div>
      <div className="flex justify-end ">
        <Pagination
          numRecords={totalRecords}
          pageSize={pageSize}
          currentPage={currentPage}
          onPageChange={(updatedPage: number) => {
            onSearchParamsUpdated({ currentPage: updatedPage });
          }}
        />
      </div>
    </div>
  );
};
